var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05406 18.2232C6.03495 18.2063 6.01689 18.1904 5.99984 18.1753V18.0686L5.76552 17.8343C4.30711 16.3759 3.4665 14.4428 3.4665 12.4V12.1458C3.59299 8.18597 6.96682 4.93333 10.9332 4.93333C11.5709 4.93333 12.3743 5.15125 13.1539 5.57104C13.9043 5.9751 14.5753 6.53553 15.0226 7.17784C15.4574 8.15492 16.8557 8.14051 17.2621 7.13462C17.6412 6.45729 18.2982 5.87138 19.0562 5.44869C19.8352 5.01422 20.6349 4.8 21.1998 4.8C25.2833 4.8 28.5398 8.03647 28.6665 12.1454V12.4C28.6665 14.5893 27.8175 16.5041 26.3926 17.8103L26.1332 18.0481V18.1452C26.108 18.1662 26.0817 18.1883 26.0545 18.2113C25.8471 18.3862 25.5653 18.629 25.2291 18.9213C24.5559 19.5066 23.654 20.3 22.6709 21.1665C22.3559 21.4441 22.0326 21.7292 21.7056 22.0176C19.9914 23.5292 18.1782 25.1282 16.9496 26.1894C16.4478 26.6035 15.6852 26.6035 15.1834 26.1894C13.7183 24.924 11.3901 22.8951 9.40962 21.1643C8.41822 20.2979 7.51451 19.5066 6.85049 18.9238C6.51841 18.6323 6.24669 18.3933 6.05406 18.2232Z",
    fill: "#FF68CC",
    stroke: "#FF68CC",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart_2.f1932a8285e520d7ad8fd4cd50b2043d.svg";
export { ForwardRef as ReactComponent };